import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuthInfo } from "./hooks";

export default function ProtectedRoute({ children }) {
  const authInfo = useAuthInfo();
  const location = useLocation();
  if (!authInfo) return <div>Loading…</div>;

  const { isAuthenticated } = authInfo;

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return children;

}
